import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    bienes: [],
  },

  getters: {
    getBienes: (state) => state.bienes,
  },

  mutations: {
    SET_BIENES(state, bienes) {
      state.bienes = bienes;
    },
  },

  actions: {
    async fetchBienes({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catbienes')
        .then((response) => {
          commit('SET_BIENES', response.data.data);
        });
    },
  },
};
